//@flow
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert2';
import HomieContext from 'HomieContext';
import AuthenticationAction from 'actions/AuthenticationAction';
import ButtonDropDown from 'components/shared/ButtonDropDownComponent';
import AdminList from './AdminListComponent';
import ExtraList from './ExtraListComponent';
import { FlexColumn } from 'styles/Layout';
import {
  Arrow,
  ProfileImageLogin,
  LoginDropDownOption,
  FullName,
  Divider
} from './styles';
import Avatar from 'AssetsRoot/images/dashboard/icon_avatar_dashboard.svg.react';
import styled from 'styled-components';

const AvatarIcon = styled(Avatar)`
  display: block;
  cursor: pointer;
`;

const DropDownLoginButton = ({ fullName }: any) => {
  return (
    <ProfileImageLogin>
      <AvatarIcon />
      <FullName>{fullName}</FullName>
      <Arrow />
    </ProfileImageLogin>
  );
};

type PropsType = {
  location: any,
  history: any
};

const Menu = ({ location, history }: PropsType) => {
  const {
    currentUser,
    showLoadingProcessView,
    hideLoadingProcessView
  } = useContext(HomieContext);

  const goToPage = (basePath: string): void => {
    history.push(basePath);
  };

  const onLogout = () => {
    showLoadingProcessView('Preparando datos');
    AuthenticationAction.logout(response => {
      if (response && response.csrf) {
        goToPage('/');
        swal({
          className: 'logout',
          icon: '',
          title: 'Has salido del sistema',
          timer: 5000,
          button: {
            text: 'OK',
            value: true,
            visible: true,
            closeModal: true
          }
        });
        hideLoadingProcessView();
      } else {
        location.reload();
      }
    });
  };

  const DropDownLoginContainer = ({ onLogout }: any) => {
    return (
      <FlexColumn>
        <Divider />
        <LoginDropDownOption onClick={onLogout}>
          Cerrar sesión
        </LoginDropDownOption>
      </FlexColumn>
    );
  };

  return (
    <ButtonDropDown
      isOpenDropDown={false}
      BodyContainer={() => {
        return (
          <FlexColumn>
            <AdminList currentUser={currentUser} />
            <ExtraList currentUser={currentUser} />
            <DropDownLoginContainer onLogout={onLogout} />
          </FlexColumn>
        );
      }}
      ButtonContainer={() => {
        return <DropDownLoginButton fullName={currentUser.fullName} />;
      }}
      alignment={'right'}
      visible={true}
    />
  );
};

Menu.displayName = 'Logout';
export default withRouter(Menu);
